import $tip from '@/assets/js/model/tip/tip.js'
import $store from '@/store/index.js'
import { instance } from '@/assets/config/axios-config.js';
import $url from '@/assets/config/address-config.js'
import axios from 'axios'
var  num = true
export default {
    shake(func, ...arg) {
        if (num) {
            num = false
            func(...arg)
            
            var timer= setTimeout(() => {
                num = true
            }, 1000)
        }
    },
    hasCode(code) {
        return $store.getters.userCodes.indexOf(code + "") != -1;
    },
    myTimeToLocal(inputTime) {
        if (!inputTime && typeof inputTime !== 'number') {
            return '';
        }
        var localTime = '';
        inputTime = new Date(inputTime).getTime();
        const offset = (new Date()).getTimezoneOffset();
        localTime = (new Date(inputTime - offset * 60000)).toISOString();
        localTime = localTime.substr(0, localTime.lastIndexOf('.'));
        localTime = localTime.replace('T', ' ');
        return localTime;
    },

    addwindowsonresize(fn) {
        if (typeof (window.onresize) == 'function') {
            let fun = window.onresize
            window.onresize = function () {
                fun()
                fn()
            }
        } else {
            window.onresize = fn
        }
    },
    getsasstoken() {

        let url = `${$url.sass}/token`

        return new Promise((resolve, reject) => {
            axios.post(url, {
                'cmd': 'get_token',
                'token': sessionStorage.getItem('token'),
                '53kf_token': 'Aj|uU620cjJ`53kf'
            }, {
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                    }
                    return ret
                }],
            })
                .then(res => {
                    return resolve(JSON.parse(JSON.stringify(res)))
                })
                .catch(err => {
                    return reject(err)
                })
        })

    },
    download(url, name) {
        instance.post(url, {
        }, {
            responseType: 'blob'
        })
            .then(res => {

                var blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                var downloadElement = document.createElement('a')
                var href = window.URL.createObjectURL(blob); //创建下载的链接
                downloadElement.style.display = 'none'
                downloadElement.href = href
                downloadElement.download = name + this.myTimeToLocal((new Date).valueOf())//下载后文件名
                document.body.appendChild(downloadElement)
                downloadElement.click() //点击下载
                document.body.removeChild(downloadElement) //下载完成移除元素
                window.URL.revokeObjectURL(href) //释放掉blob对象
                successTip('下载成功')
            })
    }

}

export const successTip = function (text) {
    $tip({
        type: 'success',
        text: text,
    })
}

export const errorTip = function (text) {
    $tip({
        type: 'error',
        text: text,
    })
}